import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { SurveyService } from "src/app/core/services/survey.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { GenericLabelValue } from "src/app/shared/models/DTO/GenericLabelValue.dto";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";
import { SurveyAnswer, SurveyAnswerType, SurveyQuestion, VenueSurveyItem } from "src/app/shared/models/survey.model";
import { v4 as uuidv4 } from "uuid";

@Component({
	selector: "app-customer-survey-setup",
	templateUrl: "./customer-survey-setup.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class CustomerSurveySetupComponent implements OnInit {
	changesToSave: boolean = false;

	editName: boolean;

	clonedSurvey: VenueSurveyItem;

	survey: VenueSurveyItem;
	surveyQuestionTypes: GenericLabelValue[] = [
		{
			label: "Multi-line Text",
			value: SurveyAnswerType.TEXTAREA,
		},
		{
			label: "Multiple Choice",
			value: SurveyAnswerType.CHOICE,
		},
		{
			label: "Scale",
			value: SurveyAnswerType.SCALE,
		},
		{
			label: "Two Options",
			value: SurveyAnswerType.BOOLEAN,
		},
		{
			label: "Text",
			value: SurveyAnswerType.TEXT,
		},
	];

	constructor(
		public app: AppService,
		public venueService: OOVenueService,
		public surveyService: SurveyService,
		private activatedRoute: ActivatedRoute,
		private focuslink: FocuslinkService,
		private router: Router
	) {}

	ngOnInit(): void {
		this.survey = this.surveyService.surveyList.value.find((i) => i.sk === this.activatedRoute.snapshot.paramMap.get("surveyKey"));
		this.clonedSurvey = JSON.parse(JSON.stringify(this.survey));
		!this.survey.created && (this.editName = true);
	}

	add() {
		this.survey.questions.push(
			new SurveyQuestion({
				key: uuidv4(),
				answer: new SurveyAnswer(),
			})
		);
	}

	back() {
		if (this.changesToSave && this.clonedSurvey) {
			this.setSurveyServiceSurvey(this.clonedSurvey);
		}
		this.router.navigate([`cc/customers/survey`], {
			queryParams: { source: this.survey.sk },
		});
	}

	async delete() {
		await this.focuslink.surveyDelete(+this.survey.pk, this.survey.sk);
		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `Survey deleted.` });
		this.surveyService.surveyList.next(
			this.surveyService.surveyList.value.splice(this.surveyService.surveyList.value.findIndex((i) => i.sk === this.survey.sk))
		);
		this.back();
	}

	async save() {
		const resp = await this.focuslink.surveyPatch(+this.survey.pk, this.survey.sk, this.survey);
		this.survey = resp;
		this.setSurveyServiceSurvey(resp);
		this.clonedSurvey = JSON.parse(JSON.stringify(this.survey));
		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `Survey saved.` });
		this.changesToSave = false;
	}

	setSurveyServiceSurvey(survey: VenueSurveyItem) {
		console.log(survey);
		const index = this.surveyService.surveyList.value.findIndex((i) => i.sk === survey.sk);
		this.surveyService.surveyList.value[index] = survey;
		this.surveyService.surveyList.next(this.surveyService.surveyList.value);
		console.log(this.surveyService.surveyList.value);
	}
}
